// Composant <see-all-button> qui active un mode “plein écran” pour best sellers ou collections puis relance le rendu
class SeeAllButton extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(e) {
    e.preventDefault();
    const section = this.getAttribute('section');
    const category = this.getAttribute('category');
    
    // ✅ NOUVEAU : Redirection directe vers InstantSearch pour best sellers
    if (section === 'showBestSellers150') {
      window.location.href = '/search?all-best-sellers=true';
      return;
    }
    
    // ✅ NOUVEAU : Redirection directe vers InstantSearch pour collections
    if (section === 'showCollectionsAll') {
      localStorage.setItem('showCollectionsView', 'true');
      window.location.href = '/search';
      return;
    }
    
    if (!section || !(section in autocompleteMode) ) {
      console.warn(`[Debug] autocompleteMode section inconnue pour see-all-button: ${section}`);
    } else {
      // AUTOCOMPLETEMODE
      // ANCIEN COMPORTEMENT COMMENTÉ : activation du mode showBestSellers150
      // autocompleteMode.showBestSellers150 = (section === 'showBestSellers150');
      // ANCIEN COMPORTEMENT COMMENTÉ : activation du mode showCollectionsAll
      // autocompleteMode.showCollectionsAll = (section === 'showCollectionsAll');
      // autocompleteMode.showCategoryCollectionsAll = (section === 'showCategoryCollectionsAll');
      autocompleteMode.showSearchCollectionsAll = (section === 'showSearchCollectionsAll');
      // ANCIEN COMPORTEMENT COMMENTÉ : gestion du mode showBestSellers150
      // if (section === 'showBestSellers150') {
      //   autocompleteMode.bestSellersPage = 0;
      //   fetchTotalBestSellers().then(() => {
      //     rerenderAutocomplete();
      //     scrollToTopOfPanel();
      //   });
      // } else 
      // ANCIEN COMPORTEMENT COMMENTÉ : gestion du mode showCollectionsAll
      // if (section === 'showCollectionsAll') {
      //   autocompleteMode.collectionsPage = 0;
      //   fetchTotalCollections().then(() => {
      //     rerenderAutocomplete();
      //     scrollToTopOfPanel();
      //   });
      // } else 
      // if (category && section === 'showCategoryCollectionsAll') {
      //   autocompleteMode.categoryCollectionsPage = 0;
      //   fetchTotalCollections(category).then(() => {
      //     rerenderAutocomplete();
      //     scrollToTopOfPanel();
      //   });
      if (section === 'showSearchCollectionsAll') {
        autocompleteMode.searchCollectionsPage = 0;
        fetchTotalSearchCollections(
          document.querySelector('.aa-Input').value
        ).then(() => {
          rerenderAutocomplete({ clearQuery: false });
          scrollToTopOfPanel();
      });
      }  else {
        rerenderAutocomplete();
        scrollToTopOfPanel();
      }
    }

    if (typeof instantSearchMode === 'undefined') {
      // instantSearchMode n'est pas déclaré sur cette page
      return;  // on arrête tout ici
    }
    if (!section || !(section in instantSearchMode)) {
      console.warn(`[Debug] instantSearchMode section inconnue pour see-all-button: ${section}`);
    } else {
      // INSTANTSEARCHMODE
      
      if (section === 'showCollectionsResults') {
        instantSearchMode.showCollectionsResults = (section === 'showCollectionsResults');
        showFullCollectionsView();
      } else if (section === 'showAllCollectionsBestSellers') {
        instantSearchMode.showAllCollectionsBestSellers = (section === 'showAllCollectionsBestSellers');
        showAllCollectionsBestSellersView(true);
      } else if (section === 'showAllProductBestSellers') {
        instantSearchMode.showAllProductBestSellers = (section === 'showAllProductBestSellers');
        showAllProductsBestSellersView(true);
      }
    }
  }
}
customElements.define('see-all-button', SeeAllButton);

// Composant <back-button> qui désactive tous les modes plein écran et relance le rendu
class BackButton extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(e) {
    e.preventDefault();
    const section = this.getAttribute('section');
    const category = this.getAttribute('category');
    if ( section === 'showAllCollectionsBestSellers' ){
      Object.keys(instantSearchMode).forEach(key => {
        instantSearchMode[key] = false;
      });
      showAllCollectionsBestSellersView(false);
    
    } else if ( section === 'showAllProductBestSellers' ) {
      Object.keys(instantSearchMode).forEach(key => {
        instantSearchMode[key] = false;
      });
      showAllProductsBestSellersView(false);
    } else if ( section === 'showCollectionsResults' ) {
      Object.keys(instantSearchMode).forEach(key => {
        instantSearchMode[key] = false;
      });
      if (category){
        showFullCollectionsView(false, true);
      } else {
        showFullCollectionsView(false);
      }
    } else if(section == 'categoryCollections'){
      Object.keys(autocompleteMode).forEach(key => {
        if (key !== "categoryPage" && key !== "showCategory" && key !== "selectedCategory" ){
          autocompleteMode[key] = false;
        }
      });
      rerenderAutocomplete();
    } else if(!section){
      Object.keys(autocompleteMode).forEach(key => {
        autocompleteMode[key] = false;
      });
      rerenderAutocomplete();
    }
  }
}
customElements.define('back-button', BackButton);

// Composant <category-card> qui, au clic, active le mode “catégorie” et récupère le total de produits pour la catégorie
class CategoryCard extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    event.preventDefault();
    const catId = this.getAttribute('cat-id');
    if (!catId) return;

    autocompleteMode.categoryPage = 0;
    autocompleteMode.showCategory = true;
    autocompleteMode.selectedCategory = catId;
    autocompleteMode.categoryTotal = null;

    rerenderAutocomplete();
    setTimeout(() => {
      scrollToTopOfPanel();
    }, 0);
  }
}
customElements.define('category-card', CategoryCard);

// Composant <load-more-button> qui incrémente la page en fonction de la section (collections, catégorie, best sellers) et relance le rendu
class LoadMoreButton extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(e) {
    e.preventDefault();
    const section = this.getAttribute('section');
    
    // ANCIEN COMPORTEMENT COMMENTÉ : incrémentation de collectionsPage
    // if (section === 'collections') {
    //   autocompleteMode.collectionsPage += 1;
    // } else 
    if (section === 'category') {
      autocompleteMode.categoryPage += 1;
    // ANCIEN COMPORTEMENT COMMENTÉ : incrémentation de bestSellersPage
    // } else if (section === 'bestSellers') {
    //   autocompleteMode.bestSellersPage += 1;
    } else if (section === 'categoryCollections') {
      autocompleteMode.categoryCollectionsPage += 1;
    } else if (section === 'searchCollections') {
      autocompleteMode.searchCollectionsPage += 1;
    } else if (section === 'searchResults') {
      autocompleteMode.searchResultsPage += 1;
    }
    rerenderAutocomplete({ clearQuery: false });
  }
}
customElements.define('load-more-button', LoadMoreButton);

// Composant <frequent-search-item> : au clic, remplit le champ de recherche avec la requête associée
class SuggestionSearchButton extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(e) {
    e.preventDefault();

    // 1) On détermine la query
    const queryTexte = this.dataset.query?.trim() || this.textContent.trim();
    if (!queryTexte) return;

    // 2) On l’ajoute aux récentes (et on limite à 3 en interne)
    addRecentSearch(queryTexte);

    // 3) On préremplit le champ et on déclenche la recherche
    const inputField = document.querySelector('.aa-Form .aa-Input');
    if (!inputField) {
      console.warn('[Debug] Impossible de trouver .aa-Form .aa-Input');
      return;
    }
    inputField.value = queryTexte;
    inputField.dispatchEvent(new Event('input'));
  }
}

customElements.define('suggestion-search-button', SuggestionSearchButton);


// Composant <variant-add-to-cart> qui gère l’affichage du bouton pour ajouter une variante au panier
class VariantAddToCart extends HTMLElement {
  constructor() {
    super();
    this._onClick = this._onClick.bind(this);
  }

  connectedCallback() {
    const variantId = this.dataset.variantId;
    const variantTitle = this.dataset.variantTitle || 'Ajouter';

    if (!variantId) {
      console.error('<variant-add-to-cart> : data-variant-id manquant');
      return;
    }

    this.setAttribute('role', 'button');
    if (!this.hasAttribute('tabindex')) {
      this.setAttribute('tabindex', '0');
    }

    this.textContent = variantTitle;
    this.addEventListener('click', this._onClick);
    this.addEventListener('keydown', e => {
      if ((e.key === 'Enter' || e.key === ' ') && !this.hasAttribute('disabled')) {
        e.preventDefault();
        this._onClick(e);
      }
    });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);
  }

  _onClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.hasAttribute('disabled')) return;

    const variantId = this.dataset.variantId;
    this.setAttribute('disabled', '');
    this.textContent = 'Ajout en cours…';

    document.dispatchEvent(new CustomEvent('cart:add', {
      detail: {
        variantId: variantId,
        qty: 1,
        vendor: this.dataset.atcVendor || '',
        typeDelivery: this.dataset.atcTypeDelivery || '',
        delivery: this.dataset.atcDelivery || '',
        productHandle: this.dataset.productHandle || '',
        event: 'search'
      }
    }));

    this.textContent = 'Ajouté ✓';
    this.dispatchEvent(new CustomEvent('cart:searchAdd', {
      detail: { variantId: variantId },
      bubbles: true,
      composed: true
    }));
  }
}
customElements.define('variant-add-to-cart', VariantAddToCart);

// Composant <icon-add-to-card> qui affiche une icône et, au clic, affiche les variantes à ajouter au panier
class IconAddToCard extends HTMLElement {
  constructor() {
    super();
    this._handle = null;
    this._onPrimaryClick = this._onPrimaryClick.bind(this);
    this._clickOutsideHandler = null;
    this._variantContainer = null;
    this._originalInnerHTML = '';
  }

  connectedCallback() {
    const card = this.closest('.aa-ProductItem');
    if (!card || !card.dataset.handle) {
      console.warn('IconAddToCard : parent .aa-ProductItem ou data-handle introuvable');
      return;
    }
    this._handle = card.dataset.handle;
    this._originalInnerHTML = this.innerHTML.trim();

    this.setAttribute('role', 'button');
    if (!this.hasAttribute('tabindex')) {
      this.setAttribute('tabindex', '0');
    }

    this.addEventListener('click', this._onPrimaryClick);
    this.addEventListener('keydown', e => {
      if ((e.key === 'Enter' || e.key === ' ') && !this.hasAttribute('disabled')) {
        e.preventDefault();
        this._onPrimaryClick(e);
      }
    });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onPrimaryClick);
    this._removeOutsideClickListener();
  }

  // Ferme le conteneur de variantes et restaure l’icône d’origine
  _closeVariantOptions() {
    if (this._variantContainer) {
      this._variantContainer.remove();
      this._variantContainer = null;
    }
    this.style.display = '';
    this.innerHTML = this._originalInnerHTML;
    this.removeAttribute('data-loaded');
    this._removeOutsideClickListener();
    this.addEventListener('click', this._onPrimaryClick);
  }

  // Retire le listener global utilisé pour détecter un clic hors du conteneur
  _removeOutsideClickListener() {
    if (this._clickOutsideHandler) {
      document.removeEventListener('click', this._clickOutsideHandler, true);
      this._clickOutsideHandler = null;
    }
  }

  _onPrimaryClick(event) {
    event.stopPropagation();
    event.preventDefault();

    if (this.hasAttribute('disabled') || this.hasAttribute('data-loaded')) {
      return;
    }

    this.setAttribute('disabled', '');
    this.innerHTML = 'Chargement…';

    const handle = this._handle;
    Promise.all([
      fetch(`/products/${handle}.js`).then(res => {
        if (!res.ok) throw new Error(`Produit introuvable (status ${res.status})`);
        return res.json();
      }),
      fetch(`/products/${handle}?view=atc-data`).then(res => res.json()).catch(() => null)
    ])
      .then(([productData, atcData]) => {
        const variants = productData.variants || [];
        if (!variants.length) {
          throw new Error('Aucune variante trouvée');
        }

        this.style.display = '';
        this.removeAttribute('disabled');
        this.removeAttribute('data-loaded');

        const card = this.closest('.aa-ProductItem');
        if (!card) {
          console.error('IconAddToCard : parent .aa-ProductItem introuvable pour injection');
          return;
        }
        const existing = card.querySelector('.aa--variantButtonsContainer');
        if (existing) existing.remove();

        const variantContainer = document.createElement('div');
        variantContainer.className = 'aa--variantButtonsContainer';

        variants.forEach(variant => {
          const btn = document.createElement('variant-add-to-cart');
          btn.className = 'aa--variantbutton';
          btn.dataset.variantId = variant.id;
          btn.dataset.variantTitle = variant.title;
          btn.dataset.productHandle = handle;
          if (atcData) {
            btn.dataset.atcVendor = atcData.vendor || '';
            btn.dataset.atcTypeDelivery = atcData.typeDelivery || '';
            btn.dataset.atcDelivery = atcData.delivery || '';
          }
          if (!variant.available) {
            btn.setAttribute('disabled', '');
            btn.textContent = `${variant.title} (Épuisé)`;
          }
          variantContainer.appendChild(btn);
        });

        this.insertAdjacentElement('afterend', variantContainer);
        this.style.display = 'none';
        this._variantContainer = variantContainer;
        this.setAttribute('data-loaded', '');

        this._clickOutsideHandler = (e) => {
          if (e.target === this) return;
          if (variantContainer.contains(e.target)) return;
          this._closeVariantOptions();
        };
        console.log('🔍 [DEBUG] IconAddToCard - DÉBUT');
        document.addEventListener('click', this._clickOutsideHandler, true);

        variantContainer.addEventListener('cart:open', () => {
          this._closeVariantOptions();
        });
      })
      .catch(err => {
        console.error('IconAddToCard → fetch produit impossible pour', this._handle, err);
        this.innerHTML = this._originalInnerHTML;
      });
  }
}
customElements.define('icon-add-to-card', IconAddToCard);

class RecentSearchRemove extends HTMLElement {
  constructor() {
    super();
    this._onClick = this._onClick.bind(this);
  }
  connectedCallback() {
    this.setAttribute('role', 'button');
    this.setAttribute('tabindex', '0');
    this.addEventListener('click', this._onClick);
    this.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this._onClick(e);
      }
    });
  }
  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);
  }
  _onClick(e) {
    e.stopPropagation();
    e.preventDefault();

    // ne supprimer que si on a cliqué sur le SVG (ou son <path>)
    if (!e.target.closest('svg')) {
      return;  
    }

    const btn = this.querySelector('suggestion-search-button');
    const query = btn?.dataset.query?.trim();
    if (!query) return;

    removeRecentSearch(query);
    rerenderAutocomplete({ clearQuery: false });
  }
}
customElements.define('recent-search-remove', RecentSearchRemove);


